import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "main-container mt-8 !items-start !content-start" }
const _hoisted_2 = { class: "actions-row flex items-center justify-end col-start-1 col-end-13" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "alt-table mobile-preserved fixed-column-1 border-collapse col-start-1 col-end-13 max-w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-2xl py-4 px-8 whitespace-nowrap text-left" }, " Ay "),
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-2xl py-4 px-8 whitespace-nowrap text-left" }, " Fiyat (₺) ")
  ])
], -1)
const _hoisted_6 = { class: "py-4 px-8 whitespace-nowrap text-left" }
const _hoisted_7 = { class: "py-4 px-8 whitespace-nowrap text-left" }

import { onBeforeMount, ref } from "vue";
    import textToggler from "../reusable/textToggler.vue";
    import { useGetElectricityPrices, updateElectricityPrice } from "../../composables/omPlatformFunctions";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'electricityPriceTable',
  setup(__props) {


    const selectedYear = ref<string>(new Date().getFullYear().toString());

    const { prices, getPrices } = useGetElectricityPrices(selectedYear.value);

    const yearOptions = [
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
    ]
    
    const months = [
    { id: "01", monthName: "Ocak" },
    { id: "02", monthName: "Şubat" },
    { id: "03", monthName: "Mart" },
    { id: "04", monthName: "Nisan" },
    { id: "05", monthName: "Mayıs" },
    { id: "06", monthName: "Haziran" },
    { id: "07", monthName: "Temmuz" },
    { id: "08", monthName: "Ağustos" },
    { id: "09", monthName: "Eylül" },
    { id: "10", monthName: "Ekim" },
    { id: "11", monthName: "Kasım" },
    { id: "12", monthName: "Aralık" }
];


    const commitPriceChange = async (month: string, newPrice: string) => {

        const newPriceNumber = parseFloat(newPrice)

        if(isNaN(newPriceNumber)){
            alert("Lütfen geçerli bir fiyat girdiğinizden emin olun.")
            return
        }

        try {
            await updateElectricityPrice(selectedYear.value, month, newPriceNumber)
            prices.value[month] = newPrice
        } catch (error) {
            alert("Bir hata oluştu. Lütfen daha sonra tekrar deneyin.")
        }
    }


    onBeforeMount(() => {

    })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("select", {
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_unref(getPrices)(selectedYear.value))),
        class: "outline-none px-8 py-2 rounded-lg bg-white text-2xl",
        name: "year",
        id: "year",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedYear).value = $event))
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(yearOptions, (year) => {
          return _createElementVNode("option", {
            key: year,
            value: year
          }, _toDisplayString(year), 9, _hoisted_3)
        }), 64))
      ], 544), [
        [_vModelSelect, selectedYear.value]
      ])
    ]),
    _createElementVNode("table", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("tbody", null, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(months, (month) => {
          return _createElementVNode("tr", {
            key: month.id
          }, [
            _createElementVNode("td", _hoisted_6, _toDisplayString(month.monthName), 1),
            _createElementVNode("td", _hoisted_7, [
              _createVNode(textToggler, {
                "edited-field": "index",
                text: _unref(prices)[month.id] ? _unref(prices)[month.id] : '0.00',
                onCompleteEdit: ($event: any) => (commitPriceChange(month.id, $event))
              }, null, 8, ["text", "onCompleteEdit"])
            ])
          ])
        }), 64))
      ])
    ])
  ]))
}
}

})